export default function TheSafeHomeController(
  $location,
  $q,
  $routeParams,
  $window,
  loaderService,
  orgDataService,
  reportsDataService,
  ssDialogService,
  userService,
  authorizationService
) {
  const vm = this;

  vm.appIsLoaded = false;

  vm.userName = '';
  vm.jumpRightInItems = null;
  
  vm.usesUnlockTheSafe = false;
  vm.unlockTheSafeItems = null;

  vm.handleUnlockTheSafeItemClick = _handleUnlockTheSafeItemClick;
  vm.handleJumpRightInItemClick = _handleJumpRightInItemClick;
  _activate();

  function _activate() {
    if (authorizationService.getToken()) {
      userService.getJumpRightInItems().then((jumpRightInItems) => {
        vm.jumpRightInItems = jumpRightInItems;
      });

      userService.getUser().then((userData) => {
        vm.userName = userData.userName;
      });

      orgDataService.getCurrentCustomer().then((cResponse) => {
        if (cResponse.data.customerTypeId === 1) {
          vm.usesUnlockTheSafe = true;
          userService.getUnlockTheSafeItems().then((unlockTheSafeItems) => {
            vm.unlockTheSafeItems = unlockTheSafeItems;
          });
        }
      });

      _doneLoading();
    } else {
      $location.path('/login');
    }
  }

  function _doneLoading() { // eslint-disable-line
    loaderService.showViewLoader = false;
    // this.appIsLoaded = true;
    _checkForViewReport();
  }

  function _checkForViewReport() {
    if ($routeParams.reportInstanceId !== undefined) {
      reportsDataService.getReportBlob($routeParams.reportInstanceId)
        .then((viewReportResponse) => {
          reportsDataService.viewReportBlob(viewReportResponse);
        });
    }
  }

  function _handleJumpRightInItemClick(jumpRightInItem) {
    $location.path(jumpRightInItem.anchorURL);
  }

  function _handleUnlockTheSafeItemClick(unlockTheSafeItem) {
    $window.open(unlockTheSafeItem.anchorURL, '_blank');
  }
}

TheSafeHomeController.$inject = [
  '$location',
  '$q',
  '$routeParams',
  '$window',
  'loaderService',
  'orgDataService',
  'reportsDataService',
  'ssDialogService',
  'userService',
  'authorizationService',
];
